// Densidade da interface: "compact" reduz a base tipográfica (rem) de 16px
// para 13px, encolhendo texto E espaçamentos do Tailwind em ~81% — mesmo
// efeito visual de deixar o navegador em 80%, sem quebrar o Leaflet (px).
const STORAGE_KEY = "ui_density";
const DEFAULT_DENSITY = "compact";

export const DENSITIES = [
  { value: "compact", label: "Compacto" },
  { value: "normal", label: "Normal" },
];

export function getDensity() {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "compact" || saved === "normal" ? saved : DEFAULT_DENSITY;
}

export function applyDensity(density) {
  document.documentElement.setAttribute("data-density", density);
}

export function setDensity(density) {
  localStorage.setItem(STORAGE_KEY, density);
  applyDensity(density);
}

applyDensity(getDensity());
